
































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util';
import AbpBase from '../../../lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
@Component
export default class showauditlogs extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: proxy.AuditLogListDto, default: new proxy.AuditLogListDto() })
  model: proxy.AuditLogListDto;
  s_model: proxy.AuditLogListDto = new proxy.AuditLogListDto();
  AuditLogService = new proxy.AuditLogServiceProxy();
  cancel() {
    this.$emit('input', false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value);
    } else {
      this.s_model = this.model;
      if (this.s_model.parameters) {
        this.s_model.parameters = JSON.stringify(
          JSON.parse(this.s_model.parameters),
          null,
          6
        );
      }
    }
  }
}
